import { FieldType } from "./types";

import { cn } from "@/lib/utils";

interface FieldLabelProps {
  name: string;
  fieldType?: FieldType;
  className?: string;
  htmlFor?: string;
}

const FieldLabel: React.FC<FieldLabelProps> = ({
  name,
  fieldType = FieldType.Default,
  className,
  htmlFor,
}) => {
  if (fieldType === FieldType.InputVariable) {
    return <div className={cn("input-variable text-xs", className)}>{`${name}`}</div>;
  }

  // Default rendering
  return (
    <label htmlFor={htmlFor} className={cn("whitespace-nowrap text-sm font-medium", className)}>
      {name}
    </label>
  );
};

export default FieldLabel;
